import React from "react";
import { Update } from "../../../../../models/reports/Update";
import { Table } from "antd";
import "./Updates.css";

interface IssueProps {
    updates: Update[];
}

interface UpdateTableType {
    key: React.Key;
    date: string;
    oldValue: string;
    value: string;
    user: string;
}

const Updates = ({ updates }: IssueProps) => {
    const sourceData = updates.map(
        (u: Update, i: number) =>
            ({
                key: `u.code-${i}`,
                date: u.processingDate,
                oldValue: u.oldValue,
                value: u.value,
                user: u.user,
            } as UpdateTableType)
    );
    const columns = [
        {
            title: "Date",
            dataIndex: "date",
            key: "date",
        },
        {
            title: "Old value",
            dataIndex: "oldValue",
            key: "oldValue",
        },
        {
            title: "New value",
            dataIndex: "value",
            key: "newValue",
        },
        {
            title: "User",
            dataIndex: "user",
            key: "user",
        },
    ];

    return (
        <>
            <Table className="updates-table" columns={columns} dataSource={sourceData} pagination={false} size="small" />
        </>
    );
};

export default Updates;
